import React from "react";

const EmailIcon = (props) => {
  const { width, height, color } = props;
  return (
    <svg
      width={width || "22"}
      height={height || "20"}
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 4L7.91302 7.91697C10.4616 9.36101 11.5384 9.36101 14.087 7.91697L21 4"
        stroke={color || "#1D1D1D"}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M1.01577 11.4756C1.08114 14.5412 1.11383 16.0739 2.24496 17.2094C3.37608 18.3448 4.95033 18.3843 8.09883 18.4634C10.0393 18.5122 11.9607 18.5122 13.9012 18.4634C17.0497 18.3843 18.6239 18.3448 19.7551 17.2094C20.8862 16.0739 20.9189 14.5412 20.9842 11.4756C21.0053 10.4899 21.0053 9.51008 20.9842 8.52439C20.9189 5.45886 20.8862 3.92609 19.7551 2.79066C18.6239 1.65523 17.0497 1.61568 13.9012 1.53657C11.9607 1.48781 10.0393 1.48781 8.09882 1.53656C4.95033 1.61566 3.37608 1.65521 2.24495 2.79065C1.11382 3.92608 1.08114 5.45885 1.01576 8.52438C0.994745 9.51007 0.994745 10.4899 1.01577 11.4756Z"
        stroke={color || "#1D1D1D"}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default EmailIcon;
